import { CompanyDto } from './company-dto.model';
import { DesignationDto } from './designation-dto.model';


export class DocumentVaultDtos implements IDocumentVaultDtos {
    id!: number;
    documentName!: string | undefined;
    companyId!: number;
    company!: CompanyDto;
    designationId!: number | undefined;
    designation!: DesignationDto;
    documentPath!: string | undefined;
    isActive!: boolean;

    constructor(data?: IDocumentVaultDtos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentName = _data["documentName"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.designationId = _data["designationId"];
            this.designation = _data["designation"] ? DesignationDto.fromJS(_data["designation"]) : <any>undefined;
            this.documentPath = _data["documentPath"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): DocumentVaultDtos {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVaultDtos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentName"] = this.documentName;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["designationId"] = this.designationId;
        data["designation"] = this.designation ? this.designation.toJSON() : <any>undefined;
        data["documentPath"] = this.documentPath;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IDocumentVaultDtos {
    id: number;
    documentName: string | undefined;
    companyId: number;
    company: CompanyDto;
    designationId: number | undefined;
    designation: DesignationDto;
    documentPath: string | undefined;
    isActive: boolean;
}

